define('lq/events/processEventActionsUrl',[],function () {
    'use strict';

    var prepareName = function(value) {
        value = value.replace(/[^a-zA-Z0-9 ]+/g, '').trim();
        return encodeURIComponent(value);
    };

    return {

        get: function (piping, section, optionalName) {
            var url = 'LicquidAction/ProcessEventActions/' + piping.actionId;
            url += '/' + prepareName(section);

            if (optionalName)
                url += '/' + prepareName(optionalName);

            var params = {
                'r': Math.floor((Math.random() * 1000000))
            };
            
            return piping.url.prepare(url, params);
        }

    };
});
